const FIELD_RANGES = [
  [0, 59], // minute
  [0, 23], // hour
  [1, 31], // day of month
  [1, 12], // month
  [0, 6], // day of week
]

const parseField = (field, [min, max]) => {
  if (field === '*') return null // null means "matches anything"
  const values = new Set()
  field.split(',').forEach((part) => {
    const [range, step] = part.split('/')
    const stepNum = step ? Number(step) : 1
    let start = min
    let end = max
    if (range !== '*') {
      if (range.includes('-')) {
        const [a, b] = range.split('-').map(Number)
        start = a
        end = b
      } else {
        start = Number(range)
        end = start
      }
    }
    for (let v = start; v <= end; v += stepNum) values.add(v)
  })
  return values
}

export const parseCron = (expression) => {
  const parts = expression.trim().split(/\s+/)
  if (parts.length !== 5) {
    return { error: 'A expressão precisa ter exatamente 5 campos.' }
  }
  try {
    const fields = parts.map((part, i) => parseField(part, FIELD_RANGES[i]))
    return { fields, error: null }
  } catch {
    return { error: 'Não foi possível interpretar essa expressão.' }
  }
}

const matches = (date, fields) => {
  const [minute, hour, dom, month, dow] = fields
  return (
    (minute === null || minute.has(date.getMinutes())) &&
    (hour === null || hour.has(date.getHours())) &&
    (dom === null || dom.has(date.getDate())) &&
    (month === null || month.has(date.getMonth() + 1)) &&
    (dow === null || dow.has(date.getDay()))
  )
}

// Brute-forces minute-by-minute — plenty fast in practice (well under a
// second, even worst case) since it's simple comparisons, and simpler to
// get right than reimplementing full croniter-style next-run math.
export const nextRuns = (fields, count, maxMinutes = 2 * 365 * 24 * 60) => {
  const runs = []
  const cursor = new Date()
  cursor.setSeconds(0, 0)
  cursor.setMinutes(cursor.getMinutes() + 1)

  for (let i = 0; i < maxMinutes && runs.length < count; i++) {
    if (matches(cursor, fields)) {
      runs.push(new Date(cursor))
    }
    cursor.setMinutes(cursor.getMinutes() + 1)
  }
  return runs
}

const WEEKDAY_NAMES = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado']
const MONTH_NAMES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
]

const describeField = (values, names, offset = 0) => {
  if (values === null) return null
  const sorted = [...values].sort((a, b) => a - b)
  return sorted.map((v) => names ? names[v - offset] : v).join(', ')
}

export const describeCron = (fields) => {
  const [minute, hour, dom, month, dow] = fields
  const minuteDesc =
    minute === null ? 'todo minuto' : `no minuto ${describeField(minute)}`
  const hourDesc = hour === null ? '' : ` da hora ${describeField(hour)}`
  const domDesc = dom === null ? '' : `, no dia ${describeField(dom)} do mês`
  const monthDesc =
    month === null ? '' : `, em ${describeField(month, MONTH_NAMES, 1)}`
  const dowDesc =
    dow === null ? '' : `, nos dias da semana: ${describeField(dow, WEEKDAY_NAMES)}`
  return `Executa ${minuteDesc}${hourDesc}${domDesc}${monthDesc}${dowDesc}.`
}
